import React from "react";
import PropTypes from "prop-types";
import { IonItem, IonLabel, IonList } from "@ionic/react";
import PercentageCell from "./PercentageCell";
import TotalServiceStatsBar from "./TotalServiceStatsBar";
import SingleServiceStatsBar from "./SingleServiceStatsBar";

function ServiceStats({ servingPlayerStats, receveingPlayerStats }) {
  console.log("ServiceStats", servingPlayerStats, receveingPlayerStats);

  return (
    <div className="ion-padding PointStats">
      <h2 className="ion-text-center">Statistiche del Servizio</h2>
      <div style={{ minHeight: "120px", width: "100%", position: "relative" }}>
        <TotalServiceStatsBar serviceData={servingPlayerStats} />
      </div>
      <h2>Prima di Servizio</h2>
      <IonList>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>Ace</IonLabel>
          <PercentageCell
            className="ion-flex"
            value={servingPlayerStats.service.acesOnFirstService}
            total={servingPlayerStats.service.firstServices}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>
            Servizio vincente
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={servingPlayerStats.service.pointsOnFirstService}
            total={servingPlayerStats.service.firstServices}
          />
        </IonItem>
        {receveingPlayerStats &&
          receveingPlayerStats.map((playerStats) => (
            <>
              <IonItem style={{ color: "var(--ion-color-danger)" }}>
                <IonLabel style={{ color: "var(--ion-color-danger)" }}>
                  Risposta vincente
                  <br />
                  <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                    {playerStats.player.name}
                  </div>
                </IonLabel>
                <PercentageCell
                  value={
                    playerStats.stats.serviceResponse.firstService.returnWinners
                  }
                  total={servingPlayerStats.service.firstServices}
                />
              </IonItem>
              <IonItem style={{ color: "var(--ion-color-success)" }}>
                <IonLabel style={{ color: "var(--ion-color-success)" }}>
                  Risposta errore forzato
                  <br />
                  <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                    {playerStats.player.name}
                  </div>
                </IonLabel>
                <PercentageCell
                  value={
                    playerStats.stats.serviceResponse.firstService
                      .returnForcedErrors
                  }
                  total={servingPlayerStats.service.firstServices}
                />
              </IonItem>
              <IonItem style={{ color: "var(--ion-color-success)" }}>
                <IonLabel style={{ color: "var(--ion-color-success)" }}>
                  Risposta errore gratuito
                  <br />
                  <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                    {playerStats.player.name}
                  </div>
                </IonLabel>
                <PercentageCell
                  style={{ color: "var(--ion-color-success)" }}
                  value={
                    playerStats.stats.serviceResponse.firstService.returnErrors
                  }
                  total={servingPlayerStats.service.firstServices}
                />
              </IonItem>
            </>
          ))}
        <IonItem style={{ color: "var(--ion-color-danger)" }}>
          <IonLabel style={{ color: "var(--ion-color-danger)" }}>
            Fallo
          </IonLabel>
          <PercentageCell
            value={servingPlayerStats.service.faults}
            total={servingPlayerStats.service.firstServices}
            label="Ace"
          />
        </IonItem>
        <IonItem>
          <IonLabel>Scambio iniziato</IonLabel>
          <PercentageCell
            value={servingPlayerStats.service.firstServicesStartedRallies}
            total={servingPlayerStats.service.firstServices}
            label="Ace"
          />
        </IonItem>
        <IonItem>
          <IonLabel>Totale</IonLabel>
          <PercentageCell
            value={servingPlayerStats.service.firstServices}
            total={servingPlayerStats.service.firstServices}
            label="Ace"
          />
        </IonItem>
        <div
          style={{
            minHeight: "120px",
            width: "100%",
            position: "relative",
            marginTop: "20px",
          }}
        >
          <SingleServiceStatsBar
            serviceData={servingPlayerStats}
            againstPlayerStats={receveingPlayerStats}
          />
        </div>
      </IonList>
      <h2>Seconda di Servizio</h2>
      <IonList>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>Ace</IonLabel>
          <PercentageCell
            className="ion-flex"
            value={servingPlayerStats.service.acesOnSecondService}
            total={servingPlayerStats.service.secondServices}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>
            Servizio vincente
          </IonLabel>
          <PercentageCell
            style={{ color: "var(--ion-color-success)" }}
            className="ion-flex"
            value={servingPlayerStats.service.pointsOnSecondService}
            total={servingPlayerStats.service.secondServices}
          />
        </IonItem>
        {receveingPlayerStats &&
          receveingPlayerStats.map((playerStats) => (
            <>
              <IonItem style={{ color: "var(--ion-color-danger)" }}>
                <IonLabel style={{ color: "var(--ion-color-danger)" }}>
                  Risposta vincente
                  <br />
                  <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                    {playerStats.player.name}
                  </div>
                </IonLabel>
                <PercentageCell
                  value={
                    playerStats.stats.serviceResponse.secondService
                      .returnWinners
                  }
                  total={servingPlayerStats.service.secondServices}
                />
              </IonItem>
              <IonItem style={{ color: "var(--ion-color-success)" }}>
                <IonLabel style={{ color: "var(--ion-color-success)" }}>
                  Risposta errore forzato
                  <br />
                  <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                    {playerStats.player.name}
                  </div>
                </IonLabel>
                <PercentageCell
                  value={
                    playerStats.stats.serviceResponse.secondService
                      .returnForcedErrors
                  }
                  total={servingPlayerStats.service.secondServices}
                />
              </IonItem>
              <IonItem style={{ color: "var(--ion-color-success)" }}>
                <IonLabel style={{ color: "var(--ion-color-success)" }}>
                  Risposta errore gratuito
                  <br />
                  <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                    {playerStats.player.name}
                  </div>
                </IonLabel>
                <PercentageCell
                  value={
                    playerStats.stats.serviceResponse.secondService.returnErrors
                  }
                  total={servingPlayerStats.service.secondServices}
                />
              </IonItem>
            </>
          ))}
        <IonItem style={{ color: "var(--ion-color-danger)" }}>
          <IonLabel style={{ color: "var(--ion-color-danger)" }}>
            Doppio fallo
          </IonLabel>
          <PercentageCell
            value={servingPlayerStats.service.doubleFaults}
            total={servingPlayerStats.service.secondServices}
          />
        </IonItem>
        <IonItem>
          <IonLabel>Scambio iniziato</IonLabel>
          <PercentageCell
            value={servingPlayerStats.service.secondServicesStartedRallies}
            total={servingPlayerStats.service.secondServices}
          />
        </IonItem>
        <IonItem>
          <IonLabel>Totale</IonLabel>
          <PercentageCell
            value={servingPlayerStats.service.secondServices}
            total={servingPlayerStats.service.secondServices}
          />
        </IonItem>
        <div
          style={{
            minHeight: "120px",
            width: "100%",
            position: "relative",
            marginTop: "20px",
          }}
        >
          <SingleServiceStatsBar
            serviceData={servingPlayerStats}
            againstPlayerStats={receveingPlayerStats}
            isFirstService={false}
          />
        </div>
      </IonList>
    </div>
  );
}

ServiceStats.propTypes = {
  servingPlayerStats: PropTypes.shape({
    service: PropTypes.shape({
      aces: PropTypes.number.isRequired,
      acesOnFirstService: PropTypes.number.isRequired,
      acesOnSecondService: PropTypes.number.isRequired,
      doubleFaults: PropTypes.number.isRequired,
      validServices: PropTypes.number.isRequired,
      validFirstServices: PropTypes.number.isRequired,
      validSecondServices: PropTypes.number.isRequired,
      faults: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
      firstServices: PropTypes.number.isRequired,
      secondServices: PropTypes.number.isRequired,
      pointsOnFirstService: PropTypes.number.isRequired,
      pointsOnSecondService: PropTypes.number.isRequired,
      firstServicesStartedRallies: PropTypes.number.isRequired,
      secondServicesStartedRallies: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  receveingPlayerStats: PropTypes.arrayOf(
    PropTypes.shape({
      player: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
      stats: PropTypes.shape({
        serviceResponse: PropTypes.shape({
          firstService: PropTypes.shape({
            returnWinners: PropTypes.number.isRequired,
            returnForcedErrors: PropTypes.number.isRequired,
            returnErrors: PropTypes.number.isRequired,
          }).isRequired,
          secondService: PropTypes.shape({
            returnWinners: PropTypes.number.isRequired,
            returnForcedErrors: PropTypes.number.isRequired,
            returnErrors: PropTypes.number.isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
    }),
  ),
};

export default ServiceStats;
